import React from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import ScatterPlotChart from './visualization/ScatterPlotChart';
import { normalizeScores } from '@/utils/normalization';

const MatrixVisualization = () => {
  const { scoredOpportunities } = useAssessment();
  const data = normalizeScores(scoredOpportunities);

  return (
    <div className="space-y-6">
      <h2 className="text-3xl md:text-4xl font-bold text-primary">
        AI projects ranked by potential impact
      </h2>
      <div className="w-full h-[600px] bg-white rounded-lg border border-gray-200 shadow-sm p-6">
        <ScatterPlotChart data={data} />
      </div>
    </div>
  );
};

export default MatrixVisualization;